import { Common } from './common.model';

import {
    Embedded,
    EmbeddedUser,
    toUserEmbedded,
} from './embed.model';

import { Inventory } from './inventory.model';

export type embed = keyof EmbedProperties;

export interface EmbedProperties {
    $createdBy: EmbeddedUser;
    $updatedBy: EmbeddedUser;
}

export type EmbedPatch<T extends embed> = Patch & Partial<Pick<EmbedProperties, T>>;

export interface EmbedPatches<T extends embed> {
    patchHistory: EmbedPatch<T>[];
    totalSize?: number;
}

export const configuration: { [K in embed]: { embed: string; transform: (patch: Patch, embedded: Embedded) => EmbedProperties[K] } } = {
    $createdBy: {
        embed: 'users',
        transform: (data: Patch, embedded: Embedded): EmbeddedUser => toUserEmbedded(data, 'createdBy', embedded),
    },
    $updatedBy: {
        embed: 'users',
        transform: (data: Patch, embedded: Embedded): EmbeddedUser => toUserEmbedded(data, 'updatedBy', embedded),
    },
};

export class Patch extends Common {
    declare id: string;
    name: string;
    status: PatchStatus;
    description: string;
    oneId: Inventory['oneId'];
    patchDate: Date;
    durationMs: number;
    softwaresCount: number;

    constructor(data: any) {
        super(data);
        this.id = data.id;
        this.name = data.name;
        this.status = data.status;
        this.description = data.description;
        this.oneId = data.oneId;
        this.patchDate = data.patchDate;
        this.durationMs = data.durationMs;
        this.softwaresCount = data.softwaresCount;
    }

    public static toPatchEmbedded<T extends embed>(data: Patch, embedded?: Embedded, customFields?: T[]): EmbedPatch<T> {
        const customData = customFields.reduce((acc, field: embed) => {
            acc[field] = configuration[field].transform(data, embedded);
            return acc;
        }, {});
        return { ...new Patch(data), ...customData } as EmbedPatch<T>;
    }

    public static toPatchesEmbedded<T extends embed>(data: Patch[], embedded: Embedded, customFields: T[] = []): EmbedPatch<T>[] {
        return data.map((ticket) => this.toPatchEmbedded(ticket, embedded, customFields));
    }
}


export enum PatchStatus {
    OK = 'OK',
    CANCELED = 'CANCELED',
    SCHEDULED = 'SCHEDULED ',
    FAILED = 'FAILED'
}
